/**
 * Canonical namespace list - the SINGLE source of truth for every namespace
 * `@packages/copy` ships. `instance.ts` (the `ns` init option, the `resources`
 * key-set checks) and `copy.ts` (the `CopyFn` type, the `getFixedT` tuple)
 * both derive from this constant, so adding a namespace here and forgetting
 * one of those sites is a compile error rather than a silent lapse (see
 * `CLAUDE.md` § "Adding a key / namespace / dialect").
 *
 * One agreement site cannot derive from this array: the `CustomTypeOptions.resources`
 * module augmentation in `instance.ts` needs the literal catalog types
 * (`typeof enInvoice`, ...), which a value-level array of strings cannot
 * supply. That block stays manual, guarded by a compile-time equality
 * assertion against `NAMESPACES` (see the comment there).
 */
export const NAMESPACES = ['invoice', 'glossary', 'activity', 'account', 'chat', 'project', 'errors', 'allocation', 'emptyState', 'omnibox', 'hub'];
